import {colors} from "@c10h/colors";
import Icon from "@components/Icon";
import {FilterType} from "@components/LocationMapForLocations";
import RadioDropdown from "@components/RadioDropdown";
import RegionTreeSelector from "@components/Region/ReduxRegionTreeSelector";
import {useTranslation} from "@i18n/client";
import React, {memo, useCallback, useMemo} from "react";
import {useTwMediaQuery} from "src/hooks/useTwMediaQuery";
import {Breakpoint} from "src/constants/breakpoint";

import {SpecialtyId} from "../../../constants/specialtyIds";
import {TreeItem} from "@components/components/Tree/ComplexTreeWrapper";
import {RegionSlug, RootStateLocation} from "../../../store/types";
import {v5Pages} from "../../_common/_constants";
import getMapOptionStyle from "@components/components/Tree/getMapOptionStyle";

type Props = {
  // @ts-expect-error TS7008: Member 'getToggleFilterHandler' implicitly has an 'any' type.
  getToggleFilterHandler;
  // @ts-expect-error TS7008: Member 'filters' implicitly has an 'any' type.
  filters;
  // @ts-expect-error TS7008: Member 'isFilterActive' implicitly has an 'any' type.
  isFilterActive;
  // @ts-expect-error TS7008: Member 'locate' implicitly has an 'any' type.
  locate;

  onRegionSelect?: (slug: RegionSlug) => unknown;

  regionSlug: RegionSlug | undefined;

  locations: RootStateLocation[];
};

const MapOptions: React.FC<Props> = ({
  getToggleFilterHandler,
  filters,
  isFilterActive,
  locate,
  onRegionSelect,
  regionSlug,
  locations,
}) => {
  const i18n = useTranslation();

  const isSm = !useTwMediaQuery(Breakpoint.MD);

  const filterButtonData = useMemo(
    () =>
      locations
        .flatMap(l => l.specialties.vals())
        .distinctBy("id")
        .filter(s => s.id !== SpecialtyId.ORTHOPEDICS && s.isVirtual === false)
        .sortBy("sortIndex")
        .map(s => ({
          func: filters.specialtyId(s.id),
          name: s.name,
          sId: s.id,
          typ: FilterType.SPECIALTY,
        })),
    [filters, locations],
  );

  const options = useMemo(
    () =>
      filterButtonData.map(f => ({
        text: f.name,
        value: f,
        selected: isFilterActive(f),
      })),
    [filterButtonData, isFilterActive],
  );

  const onSelect = useCallback(
    // @ts-expect-error TS7006: Parameter 'value' implicitly has an 'any' type.
    value => {
      getToggleFilterHandler(value)();
    },
    [getToggleFilterHandler],
  );

  const isXs = !useTwMediaQuery(Breakpoint.SM);

  const getHref = useCallback(
    (item: TreeItem<string>) => (item.children ? undefined : `${v5Pages.locations}/${item.id}`),
    [],
  );

  return (
    <div
      className="px-4 py-3 contrast-tbb bg-white"
      style={{boxShadow: `0px 1px 1px 0px ${colors.gray800 + 10}`}}
    >
      <div className="flex flex-wrap justify-end gap-1 w-full">
        <div className="flex flex-nowrap gap-1 items-center grow">
          <RegionTreeSelector
            key={regionSlug} // force re-render on region change
            buttonVariant="locations"
            hideVirtualOnly
            onSelect={onRegionSelect}
            getHref={getHref}
            initialRegionSlug={regionSlug}
            shallow
            locations={locations}
          />
          <button className={`${getMapOptionStyle(false)} hidden md:block`} onClick={locate}>
            <div className="flex items-center gap-2">
              <Icon icon="locArrow" className="jcc items-center fs14 text-gray-700 px-2 sm:px-0" />
              <span className="hidden sm:flex">{i18n.t("Locate Me")}</span>
            </div>
          </button>
        </div>
        <RadioDropdown
          text={i18n.t("Services")}
          options={options}
          onSelect={onSelect}
          anchor={!isSm && isXs ? "bottom center" : "bottom left"}
        />
      </div>
    </div>
  );
};

export default memo(MapOptions);
